// extracted by mini-css-extract-plugin
export var dividerLine = "_6a-3";
export var itemImage = "_6a-9";
export var lightDivider = "_6a-4";
export var modalContent = "_6a-5";
export var modalContentCompact = "_6a-6";
export var productCard = "_6a-a";
export var productImage = "_6a-b";
export var productImageCompact = "_6a-7";
export var productImagePlaceholder = "_6a-c";
export var productImagePlaceholderCompact = "_6a-8";
export var progressBarBackground = "_6a-1";
export var progressBarContainer = "_6a-0";
export var progressBarFill = "_6a-2";